import React from 'react';
import PawPath from './PawPath';
import styled from 'styled-components/native';
import { useAppTheme } from 'src/providers/AppThemeProvider';

export const PAW_PATH_SIZE = 200;

const FloatingPawPath: React.FC = () => {
  const { colors } = useAppTheme();
  return (
    <PawPathContainer>
      <PawPath width={PAW_PATH_SIZE} height={PAW_PATH_SIZE} color={colors.primary} />
    </PawPathContainer>
  );
};

export default FloatingPawPath;

const PawPathContainer = styled.View`
  position: absolute;
  right: 0px;
  bottom: 0px;
  z-index: -1;
`;
